export default __webpack_public_path__ + "static/media/ad.c549bfcd.svg";